<mat-form-field appearance="outline" class="mb-2 w-full">
    <mat-label>{{ label }}</mat-label>
    <mat-select [canSelectNullableOptions]="canSelectNullableOptions" placeholder="{{ placeholder }}" (opened)="onPanelOpen()"
        (selectionChange)="onSelectionChange($event.value)" #siSelectRef="matSelect">
        <cdk-virtual-scroll-viewport [itemSize]="itemsSize" [minBufferPx]="itemsSize * 10"
            [maxBufferPx]="itemsSize * 10" [style.height]="'240px'"
            [style.max-height]="itemsSize * (lists?.length > 5 ? 5 : lists?.length + 1) + 'px'"
            (scrolledIndexChange)="onVirtualScroll()">
            <mat-option *ngIf="!showEmptyOption && !lists.length" [value]="''" [disabled]="true"></mat-option>
            <mat-option *ngIf="showEmptyOption" [value]="''">--Select--</mat-option>
            <mat-option *cdkVirtualFor="let item of lists | orderBy: 'name'" [value]="item.id">
                {{ item.name }}
            </mat-option>
        </cdk-virtual-scroll-viewport>
    </mat-select>
    <fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
    <mat-spinner matSuffix *ngIf="isGetListLoading$ | async" [diameter]="18" [strokeWidth]="2"></mat-spinner>
</mat-form-field>
